export function isSupportedChain(chainId: number, supportedChains: number[]) {
  return supportedChains.includes(chainId)
}
